module.exports = __webpack_public_path__ + "img/107046.45ce80bc.png";